import axios from 'axios';
import constants from 'config/constants';

// Who has seen a notice, circular, school activity or timeline post. contentType: NOTICE_BOARD | CIRCULAR | AUDIT_LOG |
// TIMELINE_POST. The count and the list are for admins, deans and teachers; recording a view is for any login (the backend
// counts guardians and teachers only).
const BASE = `${constants.API_BASE_URL}/api/content-view`;

export const fetchViewCountService = async ({ token, contentType, contentId }) => {
  const res = await axios.get(`${BASE}/${contentType}/${contentId}/count`, constants.setHeader(token));
  return res.data?.viewCount || 0;
};

// -> [{ userId, userRole, name, students: [{ studentId, name }], viewedDateTime }] newest first, `pageNo` from 1
export const fetchViewersService = async ({ token, contentType, contentId, pageNo = 1, pageSize = 50 }) => {
  const res = await axios.get(
    `${BASE}/${contentType}/${contentId}${constants.makeParams({ pageNo, pageSize })}`,
    constants.setHeader(token)
  );
  return res.data || [];
};

export const markViewedService = ({ token, contentType, contentId }) =>
  axios.post(`${BASE}/${contentType}/${contentId}`, null, constants.setHeader(token));

export const markManyViewedService = ({ token, contentType, contentIds }) =>
  axios.post(`${BASE}/${contentType}`, { contentIds }, constants.setHeader(token));
